import 'moment/locale/it'

import { HttpClientModule } from '@angular/common/http'
import { ErrorHandler, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { SplashScreen } from '@ionic-native/splash-screen'
import { StatusBar } from '@ionic-native/status-bar'
import { IonicStorageModule } from '@ionic/storage'
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular'
import { MomentModule } from 'ngx-moment'

import { FlexMenuComponent } from '../components/flex-menu/flex-menu'
import { FlexMenuComponentModule } from '../components/flex-menu/flex-menu.module'
import { RdkDatePickerComponent } from '../components/rdk-date-picker/rdk-date-picker'
import { RdkDatePickerComponentModule } from '../components/rdk-date-picker/rdk-date-picker.module'
import { UserAuthConfig } from '../modules/mrk-user-auth/user-auth-models'
import { UserAuthModule } from '../modules/mrk-user-auth/user-auth.module'
import { AddContactPage } from '../pages/add-contact/add-contact'
import { AddContactPageModule } from '../pages/add-contact/add-contact.module'
import { AddMeetingPage } from '../pages/add-meeting/add-meeting'
import { AddMeetingPageModule } from '../pages/add-meeting/add-meeting.module'
import { CallsPage } from '../pages/calls/calls'
import { CallsPageModule } from '../pages/calls/calls.module'
import { ContactListPage } from '../pages/contact-list/contact-list'
import { ContactListPageModule } from '../pages/contact-list/contact-list.module'
import { ContractsListPageModule } from '../pages/contracts-list/contracts-list.module'
import { LoginPage } from '../pages/login/login'
import { LoginPageModule } from '../pages/login/login.module'
import { MainPage } from '../pages/main/main'
import { MainPageModule } from '../pages/main/main.module'
import { MeetingListPage } from '../pages/meeting-list/meeting-list'
import { MeetingListPageModule } from '../pages/meeting-list/meeting-list.module'
import { MeetingModalPage } from '../pages/meeting-modal/meeting-modal'
import { MeetingModalPageModule } from '../pages/meeting-modal/meeting-modal.module'
import { MeetingPage } from '../pages/meeting/meeting'
import { MeetingPageModule } from '../pages/meeting/meeting.module'
import { MeetingsToDoListPage } from '../pages/meetings-to-do-list/meetings-to-do-list'
import { MeetingsToDoListPageModule } from '../pages/meetings-to-do-list/meetings-to-do-list.module'
import { SelectAgreementPage } from '../pages/select-agreement/select-agreement'
import { SelectAgreementPageModule } from '../pages/select-agreement/select-agreement.module'
import { ShortcutsPage } from '../pages/shortcuts/shortcuts'
import { ShortcutsPageModule } from '../pages/shortcuts/shortcuts.module'
import { ApiProvider } from '../providers/api/api'
import { CallsProvider } from '../providers/api/calls.provider'
import { ContactProvider } from '../providers/api/contacts.provider'
import { ContractsProvider } from '../providers/api/contracts.provider'
import { OperatorProvider } from '../providers/operator/operator'
import { SettingsProvider } from '../providers/settings/settings'
import { AddCallPage } from './../pages/add-call/add-call'
import { AddCallPageModule } from './../pages/add-call/add-call.module'
import { CallDetailPage } from './../pages/call-detail/call-detail'
import { CallDetailPageModule } from './../pages/call-detail/call-detail.module'
import { ContactDetailPage } from './../pages/contact-detail/contact-detail'
import { ContactDetailPageModule } from './../pages/contact-detail/contact-detail.module'
import { ContractDetailPage } from './../pages/contract-detail/contract-detail'
import { ContractDetailPageModule } from './../pages/contract-detail/contract-detail.module'
import { ContractsListPage } from './../pages/contracts-list/contracts-list'
import { MyApp } from './app.component'

let pages = [
  LoginPage,
  MainPage,
  MeetingListPage,
  MeetingPage,
  SelectAgreementPage,
  AddContactPage,
  AddMeetingPage,
  AddCallPage,
  ContactListPage,
  ContactDetailPage,
  CallsPage,
  CallDetailPage,
  ContractsListPage,
  ContractDetailPage,
  MeetingsToDoListPage,
  MeetingModalPage,
  ShortcutsPage
]

let pageModules = [
  LoginPageModule,
  MainPageModule,
  MeetingListPageModule,
  MeetingPageModule,
  SelectAgreementPageModule,
  AddContactPageModule,
  AddMeetingPageModule,
  ContactListPageModule,
  ContactDetailPageModule,
  CallsPageModule,
  AddCallPageModule,
  CallDetailPageModule,
  ContractsListPageModule,
  ContractDetailPageModule,
  MeetingsToDoListPageModule,
  MeetingModalPageModule,
  ShortcutsPageModule
]

const PRODUCTION = true
const LOCAL = false

// Production
const userAuthConfigProd: UserAuthConfig = {
  baseURL: "https://mypushop.com/",
  authPath: "https://mypushop.com/o/token/",
  userPath: "https://mypushop.com/api/users/",
  clientID: "6ruvoMDAlg23ksJszbX5Id6i41RhglQZArglvoEL",
  clientSecret: "VJsw7LtCpDfv7kmwIqiOifjdKULvmPRiFKpnHgp5TSXJybPixAWorgpgvjakK2PdaFLiy4sB8O3v0Dco8miZpDibwmJJdFd5eYubfDWxZ0R8sKe1nIyJ33WooLsbiEhj"
}

// Test
const userAuthConfigTest: UserAuthConfig = {
  baseURL: "https://test.mypushop.com/",
  authPath: "https://test.mypushop.com/o/token/",
  userPath: "https://test.mypushop.com/api/users/",
  clientID: "VCk4ohdf264lIg2BvS6v4sGCsP0NFEe9y3t32kBX",
  clientSecret: "Pz8FZHlz76Xc7BXvc27tYCYBoXdbqgyvRgoVQeZQA15Z8g5D2YrpXC4YwBRUdWpEir3hvhLcC6FaVUggj280G7CXqHbXT8Y0eunNyeq1Ud8HHGFCgMdleV5rMA7Ne5Z1"
}

// LOCAL
const userAuthConfigLocal: UserAuthConfig = {
  baseURL: "http://127.0.0.1:8000/",
  authPath: "http://127.0.0.1:8000/o/token/",
  userPath: "http://127.0.0.1:8000/api/users/",
  clientID: "cGmxurfwkuValu8cJRCJ0EUHVECSXGElKWvqsU64",
  clientSecret: "rNvAJ59dJZ0Da9rfRUWAYVphyi3B4BYVdWZwvSD0EmmynnVm91Gjx8gwNlhpBYKQOMS47WgscDbID8Kj8f8dYjuMasiwt2OLzceRHTAPCIuob0JXwHYCLnJBvzNltI8J"
}

const testUserAuthConfig: UserAuthConfig = LOCAL ? userAuthConfigLocal : userAuthConfigTest
const userAuthConfig: UserAuthConfig = PRODUCTION ? userAuthConfigProd : testUserAuthConfig

@NgModule({
  declarations: [
    MyApp,

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {mode: 'md'}),
    IonicStorageModule.forRoot(),
    UserAuthModule.init(userAuthConfig),
    FlexMenuComponentModule,
    RdkDatePickerComponentModule,
    MomentModule.forRoot(),

    ...pageModules,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    FlexMenuComponent,
    RdkDatePickerComponent,
    ...pages
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    ApiProvider,
    OperatorProvider,
    SettingsProvider,
    ContactProvider,
    CallsProvider,
    ContractsProvider,
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts